import { useEffect, useState } from 'react'

import moment from 'moment'

import redTriangle from '../../../assets/icons/redTriangle.png'
import { fontSizes, fontWeights } from '../../../constants/salesStyles'
import { useSelector } from '../../../modules/store/customSelector'

import styles from './styles.module.scss'

const SubscriptionExpiryBanner = () => {
    const [daysRemaining, setDaysRemaining] = useState<undefined | number>()

    const paymentInfo = useSelector(state => state.userData.paymentInfo)
    const paymentInfoLoaded = useSelector(state => state.userData.paymentInfoLoaded)

    const getPaymentDueText = () => {
        switch (daysRemaining) {
            case 3:
                return (
                    <>
                        До окончания вашей подписки осталось <b>3 дня</b>.
                    </>
                )
            case 2:
                return (
                    <>
                        До окончания вашей подписки осталось <b>2 дня</b>.
                    </>
                )
            case 1:
                return (
                    <>
                        Ваша подписка заканчивается <b>сегодня</b>.
                    </>
                )
            default:
                break
        }
    }

    useEffect(() => {
        if (!paymentInfo) return

        const targetDate = moment(paymentInfo?.paymentDue)
        const currentDate = moment()
        setDaysRemaining(targetDate.diff(currentDate, 'days') + 1)
    }, [paymentInfo])

    if (!paymentInfoLoaded) return null
    if (!paymentInfo || !daysRemaining || daysRemaining > 3) return null

    return (
        <div className={styles.wrap}>
            <img src={redTriangle} alt="redTriangle" className={styles.icon} />
            <div>
                <p style={{ fontSize: fontSizes.xs, fontWeight: fontWeights.normal }}>
                    {getPaymentDueText()} Ваш тариф {paymentInfo.paymentRemark}. Сумма оплаты{' '}
                    {paymentInfo.paymentAmount} руб.
                    <br />
                    Пожалуйста оплатите по <a href={paymentInfo.paymentLink}>ссылке</a>.
                    <br />
                    Если вам необходим счет на безналичную оплату или обещанный платеж, свяжитесь с менеджером в Telegram{' '}
                    {/* Временно скрыто: поддержка в МАКС
                        <a href="https://max.ru/u/f9LHodD0cOIAVt7Zg_ukFhe6Qw_5sgNWro0T4-_WyxIKxbVugh-hydSRlno" target="_blank" rel="noopener noreferrer">
                            МАКС +79365150373
                        </a> или Telegram{' '}
                    */}
                    <a href="https://t.me/partsautoexpert_bot" target="_blank" rel="noopener noreferrer">
                        @partsautoexpert_bot
                    </a>
                </p>
            </div>
        </div>
    )
}

export default SubscriptionExpiryBanner
